'use es6';

import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { List as ImmutableList } from 'immutable';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import { hasSufficientViewPermission } from '../../../permissions/permission-logic';
import { getUserPermissionLevel } from '../../../data/schemas/dashboardSchema';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DashboardCountCell = ({
  parentDashboards
}) => {
  const parentCount = parentDashboards.size;
  const viewableDashboards = parentDashboards.filter(dashboard => hasSufficientViewPermission(getUserPermissionLevel(dashboard)));
  const privateDashboardCount = parentCount - viewableDashboards.size;
  return /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsx(View, {
      as: "div",
      textAlign: "left",
      children: parentCount === 0 ? parentCount : /*#__PURE__*/_jsx(Tooltip, {
        use: "longform",
        maxInlineSize: "800px",
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.delete.modal.table.appearsOn"
        }),
        title: /*#__PURE__*/_jsxs(List, {
          styled: true,
          paddingInlineStart: "500",
          children: [viewableDashboards.map(dashboard => {
            const dashboardId = dashboard.get('id');
            const formattedDate = dashboard.get('lastViewedAt') && I18n.moment.userTz(dashboard.get('lastViewedAt')).format('lll z');
            return /*#__PURE__*/_jsxs(ListItem, {
              children: [/*#__PURE__*/_jsx(Link, {
                href: `/reports-dashboard/${PortalIdParser.get()}/view/${dashboardId}`,
                external: true,
                children: dashboard.get('name')
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Text, {
                as: "small",
                children: formattedDate ? /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "reporting-action-components.actions.delete.modal.table.dashboardLastViewedHelperText",
                  options: {
                    date: formattedDate
                  }
                }) : /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "reporting-action-components.actions.delete.modal.table.dashboardNeverViewed"
                })
              })]
            }, `dashboard-${dashboardId}`);
          }), privateDashboardCount > 0 && /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'reporting-action-components.dashboards.privateDashboards',
              options: {
                count: privateDashboardCount
              }
            })
          })]
        }),
        children: /*#__PURE__*/_jsx(Link, {
          children: parentCount
        })
      })
    })
  });
};
DashboardCountCell.propTypes = {
  parentDashboards: PropTypes.instanceOf(ImmutableList).isRequired
};
export default DashboardCountCell;